/**
 * KeyValue UI Primitive
 *
 * A reusable component for displaying key-value pairs in a consistent layout.
 * Part of the HALO design system.
 */

export { KeyValue } from './KeyValue';
export type { KeyValueProps } from './KeyValue';
